const prevButton = '<button type="button" class="slick-prev">' +
  '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">' +
  '<circle cx="27" cy="26.9999" r="27" fill="white"/>' +
  '<path d="M30 32.9999L24 26.9999L30 20.9999" stroke="black"/>' +
  '</svg>' +
  '</button>';
const nextButton = '<button type="button" class="slick-next">' +
  '<svg xmlns="http://www.w3.org/2000/svg" width="54" height="54" viewBox="0 0 54 54" fill="none">' +
  '<circle cx="27" cy="27" r="27" transform="rotate(-180 27 27)" fill="white"/>' +
  '<path d="M24 21L30 27L24 33" stroke="black"/>' +
  '</svg>' +
  '</button>';
const productPrevButton = '<button type="button" class="slick-prev">' +
  '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="16" viewBox="0 0 34 16" fill="none">' +
  '<path d="M0.292893 7.29289C-0.0976311 7.68342 -0.0976307 8.31658 0.292894 8.70711L6.65686 15.0711C7.04739 15.4616 7.68055 15.4616 8.07107 15.0711C8.4616 14.6805 8.4616 14.0474 8.07107 13.6569L2.41421 8L8.07107 2.34315C8.4616 1.95262 8.4616 1.31946 8.07107 0.928932C7.68054 0.538408 7.04738 0.538408 6.65685 0.928932L0.292893 7.29289ZM34 7L1 7L1 9L34 9L34 7Z" fill="black"></path>' +
  '</svg>' +
  '</button>';  
const productNextButton = '<button type="button" class="slick-next">' +
  '<svg xmlns="http://www.w3.org/2000/svg" width="34" height="16" viewBox="0 0 34 16" fill="none">' +
  '<path d="M33.7071 8.70711C34.0976 8.31658 34.0976 7.68342 33.7071 7.29289L27.3431 0.928932C26.9526 0.538408 26.3195 0.538408 25.9289 0.928932C25.5384 1.31946 25.5384 1.95262 25.9289 2.34315L31.5858 8L25.9289 13.6569C25.5384 14.0474 25.5384 14.6805 25.9289 15.0711C26.3195 15.4616 26.9526 15.4616 27.3431 15.0711L33.7071 8.70711ZM0 9H33V7H0V9Z" fill="black"/>' +
  '</svg>' +
  '</button>';
const thumbPrevButton = '<button type="button" class="slick-prev">' +
  '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">' +
  '<path d="M1 1L7 7L13 1" stroke="black" stroke-width="2"/>' +
  '</svg>' +
  '</button>';
const thumbNextButton = '<button type="button" class="slick-next">' +
  '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="9" viewBox="0 0 14 9" fill="none">' +
  '<path d="M13 8L7 2L1 8" stroke="black" stroke-width="2"/>' +
  '</svg>' +
  '</button>';
const mobileNextButton = '<button type="button" class="slick-next">' +
  '<svg xmlns="http://www.w3.org/2000/svg" width="14" height="49" viewBox="0 0 14 49" fill="none">' +
  '<path d="M1 48.5L12.5 24.5L1 0.999999" stroke="#D9D9D9"/>' +
  '</svg>' +
  '</button>';
const mobilePrevButton = '<button type="button" class="slick-prev">' +
  '<svg xmlns="http://www.w3.org/2000/svg" width="13" height="49" viewBox="0 0 13 49" fill="none">' +
  '<path d="M12.5 1L1 25L12.5 48.5" stroke="#D9D9D9"/>' +
  '</svg>' +
  '</button>';
const imageDetailsNextButton = '<button type="button" class="slick-next">' +
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" aria-hidden="false"><path stroke="currentColor" d="m9 6 6 6-6 6"></path></svg>' +
  '</button>';
const imageDetailsPrevButton = '<button type="button" class="slick-prev">' +
  '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" aria-hidden="false"><path stroke="currentColor" d="m15 18-6-6 6-6"></path></svg>' +
  '</button>';

$('.collection-slider-list').slick({
  infinite: true,
  slidesToShow: 1,
  centerMode: true,
  variableWidth: true,
  prevArrow: prevButton,
  nextArrow: nextButton,
  responsive: [
    {
      breakpoint: 750,
      settings: {
        arrows: false,
        dots: true
      }
    }
  ]
});

$('.journal-list').slick({
  variableWidth: true,
  arrows: false,
  responsive: [
    {
      breakpoint: 899,
      settings: {
        slidesToShow: 1,
        variableWidth: false,
        centerMode: true,
        centerPadding: '50px',
      }
    }
  ]
});

$('.collection__heading').on('click', function () {
  $('.collection__heading').removeClass('active');
  $(this).addClass('active');
  $('.collection-slider-list').removeClass('active');
  $('.collection-slider-list[collection-title="' + $(this).data('title') + '"]').addClass('active');
});

document.addEventListener('product-recommendations-loaded', function (e) {
  // Check if the event was dispatched by the correct element, if necessary
  if (e.detail && e.detail.initializedElement) {
    $('.related-products-slider').slick({
      infinite: true,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      prevArrow: prevButton,
      nextArrow: nextButton,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }
});

$('.related-products__tab').on('click', function () {
  $('.related-products__tab').removeClass('active');
  $(this).addClass('active');
  $('.related-products-slider').removeClass('active');
  $('.related-products-slider[related-products="' + $(this).data('title') + '"]').addClass('active');
  if ($(this).data('title') == 'viewed') {
    $('.related-products-slider').slick('unslick').slick({
      infinite: true,
      slidesToShow: 1,
      centerMode: true,
      variableWidth: true,
      prevArrow: prevButton,
      nextArrow: nextButton,
      responsive: [
        {
          breakpoint: 750,
          settings: {
            arrows: false,
            dots: true
          }
        }
      ]
    });
  }
});

$('.product__media-list').slick({
  slidesToShow: 1,
  slidesToScroll: 1,
  fade: true,
  nextArrow: productNextButton,
  prevArrow: productPrevButton,
  // asNavFor: '.thumbnail-list',
  responsive: [
    {
      breakpoint: 750,
      settings: {
        nextArrow: mobileNextButton,
        prevArrow: mobilePrevButton,
        dots: true
      }
    }
  ]
});


$('.thumbnail-list.media-slider').slick({
  infinite: true,
  // centerMode: true,
  slidesToShow: 3,
  slidesToScroll: 1,
  vertical: true,
  verticalSwiping: true,
  focusOnSelect: true,
  asNavFor: '.product__media-list',
  nextArrow: thumbNextButton,
  prevArrow: thumbPrevButton
});

// $(".collection .card__inner-wrapper, .product__media-item").on('click', function (e) {
$(".product__media-item").on('click', function (e) {
  let productHandle = $(this).attr('product-handle');
  let mediaIndex = $(this).attr('index');

  (async () => {
    try {
      let response = await fetch(productHandle);
      let data = await response.json();
      let mainGallery = '';
      let thumbnailGallery = '';
      data.product.images.forEach((image, index) => {
        mainGallery += '<div class="product__media-main-item" index="' + index + '"><div class="image-container"><div class="image-wrap"><img src="' + image.src + '" loading="lazy"></div></div></div>';
        thumbnailGallery += '<button type="button" index="' + index + '"><img src="' + image.src + '" loading="lazy"></button>';
      });
      $('.product-main-gallery').html(mainGallery);
      thumbnailGallery += '<span class="slider-bar"></span>';
      $('.product-thumb-gallery-container').html(thumbnailGallery);
      $('body').css('overflow', 'hidden');
      $('.product-media-lightbox').addClass('active');

      if (window.matchMedia("only screen and (max-width: 768px)").matches) {
        // Initialize slick if not already initialized
        if (!$(".product-main-gallery").hasClass('slick-initialized')) {
          $(".product-main-gallery").slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            nextArrow: imageDetailsNextButton,
            prevArrow: imageDetailsPrevButton,
            dots: true
          });
        }
      } else {
        scrollIntoSelectedImage(mediaIndex);
      }

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  })();
});

$('.lightbox-close-button').on('click', function (e) {
  $('body').css('overflow', 'unset');
  $('.product-media-lightbox').removeClass('active');

  if ($(".product-main-gallery").hasClass('slick-initialized')) {
    $(".product-main-gallery").slick('unslick');
  }
});

$('.product-thumbnail-gallery').on('click', 'button', function () {
  let index = $(this).attr('index');
  scrollIntoSelectedImage(index);
});

function scrollIntoSelectedImage(index) {
  let element = $('.product__media-main-item[index="' + index + '"]');
  element[0].scrollIntoView({
    behavior: 'smooth',
    block: 'nearest',
    inline: 'start'
  });
}

$('.product-main-gallery').on('scroll', function () {
  let scrollPos = $(this).scrollTop();
  let slideHeight = $(this).find('.product__media-main-item').first().outerHeight(true);
  let index = Math.round(scrollPos / slideHeight);
  $('.product-thumb-gallery-container .slider-bar').css('transform', 'translateY(' + (index * 82 + index * 20) + 'px)');
});

// Global scale for zoom
const ZOOM_SCALE = 3;
// Movement threshold (in pixels).
const MOVE_THRESHOLD = 5;

// Time (ms) to wait for second tap on mobile
const DOUBLE_TAP_DELAY = 300;

// Tracks last tap time (for mobile double-tap detection).
let lastTapTime = 0;

// Keep track of active image if user is dragging.
let $activeImg = null;

// -------------------------------------------
// Simple helper to detect "mobile" user agents
// -------------------------------------------
function isMobileDevice() {
  // return /Android|iP(hone|od|ad)|BlackBerry|IEMobile|Opera Mini|Windows Phone|Mobile|SymbianOS|MQQBrowser|XiaoMi|MiuiBrowser/i.test(
  //   navigator.userAgent
  // );
  return window.innerWidth < 768;
}

// -------------------------------------------
// MOUSEDOWN: Possibly start a drag or click
// -------------------------------------------
$(document).on("mousedown touchstart", ".product__media-main-item .image-wrap", function (e) {
  // Support both mouse and touch events:
  // If it's a touch event, e.clientX/Y might be undefined,
  // so we take from e.originalEvent.touches[0]
  const isTouch = e.type === "touchstart";
  const clientX = isTouch ? e.originalEvent.touches[0].clientX : e.clientX;
  const clientY = isTouch ? e.originalEvent.touches[0].clientY : e.clientY;

  const $img = $(this);
  $img.data("mouseDownX", clientX);
  $img.data("mouseDownY", clientY);
  $img.data("mouseMoved", false);
  $img.data("startX", clientX);
  $img.data("startY", clientY);

  // Only allow dragging if image is zoomed in
  const isZoomedIn = $img.data("isZoomedIn") || false;
  if (isZoomedIn) {
    // Prevent text selection or image ghost-drag
    e.preventDefault();
    $activeImg = $img;
    $img.data("isDragging", true);
  }
});

// -------------------------------------------
// MOUSEMOVE/TOUCHMOVE: Pan if image is zoomed in and dragging
// -------------------------------------------
$(document).on("mousemove touchmove", function (e) {
  if (!$activeImg) return;

  const $img = $activeImg;
  const isDragging = $img.data("isDragging");
  if (!isDragging) return;

  $img.data("mouseMoved", true);

  // Get current offset
  let offsetX = $img.data("offsetX") || 0;
  let offsetY = $img.data("offsetY") || 0;

  // Handle both mouse and touch
  const isTouch = e.type === "touchmove";
  const clientX = isTouch ? e.originalEvent.touches[0].clientX : e.clientX;
  const clientY = isTouch ? e.originalEvent.touches[0].clientY : e.clientY;

  const startX = $img.data("startX");
  const startY = $img.data("startY");

  // Calculate delta
  const deltaX = clientX - startX;
  const deltaY = clientY - startY;

  offsetX += deltaX;
  offsetY += deltaY;

  $img.css("transform", `translate3d(${offsetX}px, ${offsetY}px, 0) scale(${ZOOM_SCALE})`);

  // Store new offset and start positions
  $img.data("offsetX", offsetX);
  $img.data("offsetY", offsetY);
  $img.data("startX", clientX);
  $img.data("startY", clientY);

  // Prevent scrolling the page on mobile while panning
  if (isTouch) {
    e.preventDefault();
  }
});

// -------------------------------------------
// MOUSEUP/TOUCHEND: Decide if it's a click/tap or a drag
// -------------------------------------------
$(document).on("mouseup touchend", ".product__media-main-item .image-wrap", function (e) {
  const $img = $(this);
  const isZoomedIn = $img.data("isZoomedIn") || false;
  const isDragging = $img.data("isDragging") || false;
  const mouseMoved = $img.data("mouseMoved");

  // If we were dragging, stop now
  if (isDragging) {
    $img.data("isDragging", false);
    $activeImg = null;
  }

  // For distance checking, use the stored mouseDown coords
  // and the final clientX/Y
  const isTouch = e.type === "touchend";
  let clientX, clientY;
  if (isTouch && e.originalEvent.changedTouches) {
    clientX = e.originalEvent.changedTouches[0].clientX;
    clientY = e.originalEvent.changedTouches[0].clientY;
  } else {
    clientX = e.clientX;
    clientY = e.clientY;
  }

  const downX = $img.data("mouseDownX");
  const downY = $img.data("mouseDownY");
  const distX = clientX - downX;
  const distY = clientY - downY;
  const distanceMoved = Math.sqrt(distX * distX + distY * distY);

  // If the user hasn't moved significantly => treat as a possible tap/click
  if (distanceMoved <= MOVE_THRESHOLD && !mouseMoved) {
    if (isMobileDevice()) {
      // -----------------------------
      // MOBILE DOUBLE-TAP detection
      // -----------------------------
      const now = Date.now();
      if (now - lastTapTime < DOUBLE_TAP_DELAY) {
        // It's a double tap => toggle zoom
        toggleZoom($img, e);
        lastTapTime = 0;
      } else {
        // First tap; record time
        lastTapTime = now;
      }
    } else {
      // ------------
      // DESKTOP: Single click toggles zoom
      // ------------
      toggleZoom($img, e);
    }
  }
});

// If mouse/touch ends outside the image, end dragging
$(document).on("mouseup touchend", function () {
  if ($activeImg) {
    $activeImg.data("isDragging", false);
    $activeImg = null;
  }
});

// -------------------------------------------
// Toggle Zoom Helper
// -------------------------------------------
function toggleZoom($img, event) {
  let isZoomedIn = $img.data("isZoomedIn") || false;
  let offsetX = $img.data("offsetX") || 0;
  let offsetY = $img.data("offsetY") || 0;

  if (!isZoomedIn) {
    // Zoom in at the clicked/tapped point
    isZoomedIn = true;
    $('.product-main-gallery').addClass("image-zoom");

    // Calculate transform to center where the user clicked/tapped
    const rect = $img[0].getBoundingClientRect();
    // For touches, event.clientX/Y might not be set, so handle gracefully:
    const clientX = event.clientX || (event.originalEvent.touches ? event.originalEvent.touches[0].clientX : 0);
    const clientY = event.clientY || (event.originalEvent.touches ? event.originalEvent.touches[0].clientY : 0);

    const clickX = clientX - rect.left;
    const clickY = clientY - rect.top;

    const centerX = rect.width / 2;
    const centerY = rect.height / 2;

    const diffX = clickX - centerX;
    const diffY = clickY - centerY;

    offsetX = -diffX * (ZOOM_SCALE - 1);
    offsetY = -diffY * (ZOOM_SCALE - 1);

    $img.css("transform", `translate3d(${offsetX}px, ${offsetY}px, 0) scale(${ZOOM_SCALE})`);
  } else {
    // Zoom out
    isZoomedIn = false;
    offsetX = 0;
    offsetY = 0;
    $img.css({
      transform: "translate3d(0, 0, 0) scale(1)",
    });
    $('.product-main-gallery').removeClass("image-zoom");
  }

  // Save new states
  $img.data("isZoomedIn", isZoomedIn);
  $img.data("offsetX", offsetX);
  $img.data("offsetY", offsetY);
}
